<template>
  <v-app class='font-weight-light'>
    <v-app-bar app fixed
      :color = 'this.$vuetify.theme.dark? `default`:`grey lighten-3`'
      :style = '`box-shadow: 0 0 40px 2px ${$store.getters.appTheme.shadow};`'
      class = 'pl-sm-3 pr-sm-4 px-2'
    >
      <v-toolbar-title class = 'pl-0 ml-0 mr-2'>
        <template v-if="$route.params.project_id == 293">
            <router-link
                :to = "{ name: 'reports' }"
                tag = "span"
                :style = '{backgroundImage: `url(${require(`@/assets/logos/colab.png`)})`}'
                class = 'title font-weight-light company_logo'
            >
            </router-link>
        </template>
        <template v-else>
            <router-link
              :to = "{ name: 'reports' }"
              tag = "span"
              :style = '{backgroundImage: `url(${require(`@/assets/logos/${$store.getters.headerLogo}`)})`}'
              class = 'title font-weight-light company_logo'
            >
            </router-link>
        </template>


      </v-toolbar-title>
      <v-divider vertical class = 'ml-sm-2 ml-1 mr-sm-4 mr-2 py-2' inset v-if = '$store.state.isLoggedIn && !$store.getters.objectsProgress'></v-divider>
      <v-toolbar-items v-if = '$store.state.isLoggedIn && !$store.getters.objectsProgress'>
        <main-menu></main-menu>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <span
        class = 'body-1 font-weight-light px-12 mx-2'
        v-if = '$vuetify.breakpoint.smAndUp && $route.name != "auth" && $route.name != "about"'
        v-html = '$store.state.headerSecondary'
      ></span>
      <user-menu v-if = '$store.state.isLoggedIn' class = 'mr-0'></user-menu>
      <span v-if = '$route.name == "about"'>
        <a
          class = 'header__link__black'
          href="tel:+7(495)-604-12-44"
        >+7 (495) 604-12-44</a>
      </span>
      <span v-if = '$route.name == "auth" && $store.state.brandingOption == "artics" && !$store.getters.objectsProgress'>
        <v-btn to = 'about' text style = 'text-transform: lowercase;' :color='$store.getters.uiAccent'><v-icon left>mdi-information-variant</v-icon>О системе</v-btn>
      </span>
    </v-app-bar>
    <v-main>
      <v-layout fill-height column align-center justify-center v-if = '$store.getters.objectsProgress'>
        <v-progress-circular indeterminate :color = '$store.getters.uiAccent' size = '32' width = '1'></v-progress-circular>
      </v-layout>
      <router-view v-if = '!$store.getters.objectsProgress || !$route.meta.requiresAuth' />
    </v-main>
    <v-footer :color = 'this.$vuetify.theme.dark? `default`:`grey lighten-3`'  :style = '`box-shadow: 0 0 40px 2px ${$store.getters.appTheme.shadow};`'>
      <v-layout row class = 'mx-3 grey--text text--darken-1' justify-space-between>
        <span class = 'caption'>
          <v-btn :to = '{ name: "privacy" }' x-small text color = '#757575'>Политика конфиденциальности</v-btn>
        </span>
        <span class = 'caption'>{{copyrightName}} &copy; {{ new Date().getFullYear() }}</span>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<style>
  html, .theme--light.v-application {
    background: #ECECEC;
  }

  a.header__link__black {
    color: black !important;
    text-decoration: none !important;
  }
  a.header__link__black:hover {
    text-decoration: underline !important;
  }
  .theme--light.v-menu__content {
    border-radius: 4px !important;
    box-shadow: 0px 0px 30px 1px rgba(217,217,217,0.9) !important;
  }
  .theme--dark.v-menu__content {
    border-radius: 4px !important;
    box-shadow: 0px 0px 30px 1px rgba(51, 51, 51, 0.5) !important;
  }
  .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
  .theme--light .v-text-field--outline>.v-input__control>.v-input__slot {
      border-width: 1px !important;
  }
  .theme--light .v-expansion-panel__header {
    padding: 0 16px !important;
  }
  .nav_menu_toggle {
    border-radius: 0 !important;
    text-decoration: none !important;
    font-weight: normal !important;
    font-size: 18px !important;
    user-select: none !important;
  }
  @media (max-width: 600px) {
    .nav_menu_toggle {
      font-size: 14px !important;
    }
  }
  .theme--light .nav_menu_toggle {
    color: #212121 !important;
  }
  .theme--dark .nav_menu_toggle {
    color: #b8b8b8 !important;
  }
  .theme--light .nav_menu_toggle:hover {
    color: #757575 !important;
  }
  .theme--dark .nav_menu_toggle:hover {
    color: #ebebeb !important;
  }
  .v-toolbar__title {
    padding-left: 0 !important;
  }
  .company_logo {
    display: flex;
    align-items: center;
    order: 1;
    cursor: pointer;
    height: 100%;
    min-width: 130px;
    width: 130px;
    min-height: 64px;
    background-position: left center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  @media (max-width: 600px) {
    .company_logo {
      min-width: 70px;
      width: 70px;
    }
  }
  .header_title {
    order: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 300;
    font-size: 26px;
  }
  .v-breadcrumbs__item, .v-breadcrumbs .v-icon {
    font-size: 10px !important;
  }
  @media (max-width: 600px) {
    .v-breadcrumbs__item, .v-breadcrumbs .v-icon {
      font-size: 8px !important;
    }
  }
  .theme--light .v-breadcrumbs__item {
    color: #424242 !important;
  }
  .theme--dark .v-breadcrumbs__item {
    color: #ebebeb !important;
  }
  .v-breadcrumbs__item:hover {
    text-decoration: underline;
  }
  .theme--light .v-breadcrumbs li:nth-child(even) {
    padding: 0 0 !important;
  }
  .v-toolbar__content {
    padding: 0 !important;
  }
  @media (max-width: 600px) {
    header.v-app-bar {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
    .v-main, .v-main__wrap, .v-content__wrap {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .v-main .container, .v-main .layout {
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-top: 0 !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .visualContainerHost, .visualContainerOutOfFocus {
      padding-left: 0 !important;
      margin-left: 0 !important;
    }
  }
</style>

<script>

  import UserMenu from '@/components/elements/complex/UserMenu.vue'
  import MainMenu from '@/components/elements/complex/MainMenu.vue'

  export default {
    path: '/',
    name: 'Digits',
    components: {
      'user-menu': UserMenu,
      'main-menu': MainMenu
    },
    data: () => ({}),
    computed: {
      copyrightName() {
        let brand = this.$store.state.brandingOption;
        let cname = '';
        switch (brand) {
          case 'artics':
            cname = 'Артикс';
            break;
          case 'daskipper':
            cname = ' DA!skipper, llc.'
        }
        return cname
      },
      isUiDark() {
        return this.$store.state.userData.meta && this.$store.state.userData.meta.theme || 'light'
      }
    },
    methods: {},
    created() {
      this.$store.dispatch('fillBrandingVariant', document.location.hostname);
    },
    watch: {
      isUiDark (value) {
        this.$vuetify.theme.dark = value == 'dark'
      }
    },
    mounted() {
       this.$vuetify.theme.dark = this.isUiDark == 'dark'
    }
  };
</script>
